import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@material-ui/core';
import { t } from '../../providers/TranslationProvider';

const useStyles = makeStyles((theme) => ({
    topBarInner: {
        padding: '10px 13px 0px',
        color: theme.palette.text.mainGreen,
        maxWidth: '150px',
        float: 'right',
        marginTop: '-81px',
        overflow: 'hidden',
        '& .MuiButtonBase-root': {
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '@media (max-width:1340px)': {
            padding: '20px 15px 0px',
        },
        '@media (max-width:1100px)': {
            padding: '15px 0px 0px 0px',
        },
        '@media (max-width:600px)': {
            maxWidth: '119px',
            marginTop: '-70px',
            padding: 0,
        },
    },
    topBarRight: {
        fontSize: '0.875rem',
        fontWeight: '100',
        float: 'right',
        color: theme.palette.text.mainGreen,
        marginRight: '40px',
        '@media (max-width:1100px)': {
            marginRight: '0px',
        },
    },
    smallText: {
        fontSize: '0.875rem',
        display: 'inline-block',
        padding: ' 0px 6px 0px 0px',
        color: theme.palette.common.darkGreen,
    },
    nav: {
        color: theme.palette.text.mainGreen,
        '&:hover': {
            cursor: 'pointer',
        },
    },
    navInactive: {
        color: 'lightgray',
        pointerEvents: 'none',
    },
    pagination: {
        color: '#000000',
    },
    currentPage: {
        background: '#E2EFD5',
        width: '32px',
        height: '27px',
        textAlign: 'center',
        paddingTop: '5px',
        float: 'left',
    },
}));

const SmallPagination = ({ totalElements, component, count, size, page, onChangePage }) => {
    /**
     * pages options generated based on totalElements and default page size
     * Example:
     * Default value is 10.
     * Possibile options:  increment of 10 based on total number of items
     */

    const classes = useStyles();
    const totalPages = totalElements % size > 0 ? Math.floor(totalElements / size) + 1 : Math.floor(totalElements / size);

    const changePage = (event, newPage) => {
        onChangePage(event, newPage - 1);
    };

    const setPreviousPage = (event, newPage) => {
        onChangePage(event, newPage);
    };

    const setNextPage = (event, newPage) => {
        onChangePage(event, newPage);
    };

    let disableLeft = false;
    let disableRight = false;
    // counter to display the correct number if all results are returned

    // set the navigation chevrons style to inactive when needed and prevent actions
    let navClassRight = classes.nav;
    if (totalPages <= page + 1) {
        navClassRight = classes.navInactive;
        disableRight = true;
    }
    let navClassLeft = classes.nav;
    if (page === 0) {
        navClassLeft = classes.navInactive;
        disableLeft = true;
        if (totalPages <= page + 1) {
            disableRight = true;
        } else {
            disableRight = false;
        }
    }

    let currentPage = page + 1;

    return (
        <div>
            <Grid container spacing={0} className={classes.topBarInner}>
                <Grid item xs={12}>
                    <IconButton
                        disableFocusRipple
                        id="previous-page-btn"
                        aria-label={t('previous.page')}
                        className={classes.margin}
                        style={{ float: 'left', paddingTop: '8px' }}
                        size="small"
                        onClick={!disableLeft ? (e) => setPreviousPage(e, page - 1) : null}
                        aria-disabled={disableLeft ? true : false}
                        disabled={disableLeft ? true : false}>
                        <FontAwesomeIcon
                            role="presentation"
                            icon={faChevronLeft}
                            className={navClassLeft}
                            style={{ marginLeft: '6px', marginRight: '20px' }}
                            aria-hidden="true"
                            focusable="false"
                        />
                    </IconButton>
                    <div className={classes.currentPage}>{currentPage}</div>

                    <IconButton
                        disableFocusRipple
                        id="next-page-btn"
                        aria-label={t('next.page')}
                        className={classes.margin}
                        style={{ float: 'left', paddingTop: '8px' }}
                        size="small"
                        onClick={!disableRight ? (e) => setNextPage(e, page + 1) : null}
                        aria-disabled={disableRight ? true : false}
                        disabled={disableRight ? true : false}>
                        <FontAwesomeIcon
                            role="presentation"
                            icon={faChevronRight}
                            className={navClassRight}
                            style={{ marginLeft: '20px', marginRight: '6px' }}
                            aria-hidden="true"
                            focusable="false"
                        />
                    </IconButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default SmallPagination;
